<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px">
  <div fxFlex="50%" fxFlex.xs="100%">
    <div fxLayout="column">
      <p>Tischnummer: {{ tableNumberService.getTableNumber() }}</p>
      <div *ngFor="let category of itemOverviewData" class="category">
        <h2>{{ category.category.text }}</h2>
        <div *ngFor="let item of category.categoryItems;" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button (click)="removeItem(item)">
            <mat-icon>remove</mat-icon>
          </button>
          <button
            mat-button
            class="full-width-button"
            color="primary"
            [style.fontSize]="getButtonFontSize(item.name)"
            (click)="addItem(item)"
            [ngClass]="{'orange-button': !item.infiniteQuantity && item.remainingQuantity < 20}">
            <span class="button-content">
              <span class="left-group">
                <span class="item-name">{{ item.name }}</span>
                <span class="price">€ {{ item.price.toFixed(2) }}</span>
              </span>
              <span class="pcs" *ngIf="!item.infiniteQuantity && item.remainingQuantity < 20">{{ item.remainingQuantity }} Stk.</span>
            </span>
          </button>
          <span class="counter">{{ getItemQuantity(item) }}</span>
        </div>
        <mat-form-field *ngIf="category.category.allowComment" appearance="fill" class="comment-field" fxFlexFill>
          <mat-label>Kommentar (nur {{ category.category.text }})</mat-label>
          <textarea matInput #commentInput [(ngModel)]="commentTexts[category.category.identifier]" (blur)="addComment(commentInput.value, category.category.identifier)" placeholder="Kommentar hinzufügen"></textarea>
        </mat-form-field>
      </div>

      <div [@slideInOut] class="summary-line" [class.loading]="isLoading">
        <div class="summary-content">
          <span>Artikel: {{ itemsCounter }} </span>
          <span>Preis gesamt: {{ totalAmount  | currency: 'EUR': 'symbol' }}</span>
          <div class="send" (click)="openSummary()">
            <span>{{ isLoading ? 'wird gesendet' : 'senden' }}</span>
            <button mat-icon-button [disabled]="isLoading">
            <mat-icon>navigate_next</mat-icon>
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
